import { AppointmentTypeBulkColorAssignmentBanner } from '../../../components/banners/appointment-type-bulk-color-assignment-banner';
import { useCalendarLocationIds } from '../../../stores/calendar-location.store';
import { OnboardingFlowAutoMessagesBanner } from './onboarding-flow-auto-messages-banner';
import { CalendarV3TimezoneBanner } from './timezone-banner';

export const CalendarV3PageBanners = () => {
  const { calendarLocationIds } = useCalendarLocationIds();
  return (
    <>
      <AppointmentTypeBulkColorAssignmentBanner isCalendarView locationIds={calendarLocationIds} />
      <CalendarV3TimezoneBanner />
      <OnboardingFlowAutoMessagesBanner />
    </>
  );
};
